const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/settings/open-positions/hired.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';
import i18n from '@/common/translations/i18n';
import { compactPicklistFilterSchema } from '@/common/zod-schemas/common/compactFilterSchemas';
const hiredPositionsSearchSchema = z.object({
  locationId: compactPicklistFilterSchema,
  roleId: compactPicklistFilterSchema,
  skillId: compactPicklistFilterSchema,
  teamId: compactPicklistFilterSchema
});
export const Route = createFileRoute('/(app)/org/$org/settings/open-positions/hired')({
  validateSearch: zodValidator(hiredPositionsSearchSchema),
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  loader: (): LoaderData => ({
    crumb: i18n.t($ => $.openPositions.tabs.hired, {
      ns: 'teams'
    })
  })
});